let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hF3Lf")).then(() => parcelRequire('LCM7i'));